import { RegiaoDto } from "src/app/pagamento/models/regiao-dto";

export const REGIAO_DTO: RegiaoDto[] = [
  { codigo: 1, descricao: "1a." },
  { codigo: 2, descricao: "2a." },
  { codigo: 3, descricao: "3a." },
  { codigo: 4, descricao: "4a." },
  { codigo: 5, descricao: "5a." },
  { codigo: 6, descricao: "6a." },
  { codigo: 7, descricao: "7a." },
  { codigo: 8, descricao: "8a." },
  { codigo: 9, descricao: "9a." },
  { codigo: 10, descricao: "10a." }
];